import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
  return `https://filmnet-api-internal-nightly.scratnet.com/transcoding`
};

function api() {
  return {
    getFile: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(getUrl(), {
        params: params
      });
    },

    saveFile: (data: RequestData) => {
      return HttpRequest.post(
        getUrl(),
        data.payload,
        {}
      );
    },
  };
}

export default api();
